/**
 * MD-26 Social Insight - MERGED vao MD-29 Content tab Social 2026-05-12.
 *
 * Route `/dashboard/social` redirect 302 -> `/dashboard/content` (preserve backward link).
 * Component `SocialInsightPanel` (tach ra file rieng) embedded trong Content.tsx tab Social.
 *
 * Spec: F-A-CONTENT-MGMT.md AC-18 + DECISIONS s2026-05-12-HUB-PRUNE-MD26-MERGE-MD29.
 */

import { Navigate } from 'react-router-dom';

export function DashboardSocialRoute() {
  return <Navigate to="/dashboard/content" replace />;
}
